import { Box, Typography } from '@mui/material';

import type { BenchmarkMonitoring } from '../../Benchmarks/types';
import { DASH } from '../tokens';
import { AssignmentMonitoringCard } from './AssignmentMonitoringCard';
import { BenchmarkMonitoringTile } from './BenchmarkMonitoringTile';

export const BENCHMARK_COMING_SOON = 'A new benchmark completion monitoring experience is coming soon.';

// TEMPORARY: until the benchmark monitoring backend ships, the Benchmark
// Monitoring slot carries a coming-soon card so the dashboard is never empty.
// Once the district has benchmark data the live tile takes the slot.
function BenchmarkComingSoonCard() {
  return (
    <Box
      component="section"
      role="region"
      aria-label="Benchmark Monitoring"
      sx={{
        flex: '1 1 0',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        padding: '24px',
        bgcolor: DASH.cardBg,
        border: `1px solid ${DASH.rowBorder}`,
        borderRadius: '12px',
        boxSizing: 'border-box',
      }}
    >
      <Typography component="h2" sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, color: DASH.ink, m: 0 }}>
        Benchmark Monitoring
      </Typography>
      <Typography sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: 400, color: DASH.muted }}>
        {BENCHMARK_COMING_SOON}
      </Typography>
    </Box>
  );
}

// The monitoring pair under the setup strip: Benchmark Monitoring on the left,
// Assignment Monitoring on the right. The Assignment card fetches its own data.
export function MonitoringRow({ benchmarkMonitoring }: { benchmarkMonitoring?: BenchmarkMonitoring | null } = {}) {
  return (
    <Box
      data-testid="monitoring-row"
      sx={{ display: 'flex', alignItems: 'stretch', gap: '16px', '& > *': { flex: '1 1 0', minWidth: 0 } }}
    >
      {benchmarkMonitoring ? <BenchmarkMonitoringTile data={benchmarkMonitoring} /> : <BenchmarkComingSoonCard />}
      <AssignmentMonitoringCard />
    </Box>
  );
}
